// Components
import { StyledTitleModal } from './CancelOrderModalStyles';
import { Modal, ModalSize } from '@/components';

interface DeleteProductForbiddenModalProps {
  isOpenModal: boolean;
  closeModal: () => void;
  message: string;
}

const DeleteProductForbiddenModal = ({ isOpenModal, closeModal, message }: DeleteProductForbiddenModalProps) => {
  return (
    <Modal visible={isOpenModal} onCancel={closeModal} size={ModalSize.LARGE}>
      <StyledTitleModal>{message}</StyledTitleModal>
    </Modal>
  );
};

export default DeleteProductForbiddenModal;
